export var PACKAGE_NAME = 'react-loosely-lazy';
export var MODE = {
  RENDER: 'RENDER',
  HYDRATE: 'HYDRATE'
};
export var PHASE = {
  PAINT: 0,
  AFTER_PAINT: 1,
  LAZY: 2
};
export var PRIORITY = {
  HIGH: 0,
  LOW: 2
};
export var PHASE_LAZY_DELAY = 50;
export var COLLECTED = new Map();
export var SETTINGS = {
  CURRENT_MODE: MODE.HYDRATE,
  MANIFEST: {
    publicPath: '/',
    assets: {}
  },
  CROSS_ORIGIN: undefined
};